import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=d1a83362&scoped=true&"
var script = {}
import style0 from "./logo.vue?vue&type=style&index=0&id=d1a83362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a83362",
  null
  
)

export default component.exports